export const serverBaseUrl = 'https://logic.inventic.tech/api/';
